import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-quote-details',
  templateUrl: './quote-details.component.html',
  styleUrls: ['./quote-details.component.scss']
})
export class QuoteDetailsComponent implements ICellRendererAngularComp {

  params!: ICellRendererParams;
  details: any = {};
  customer_details: any = {};
  customer_address_details: any = {};
  internal_sales_details: any = {};
  financial_details: any = {};
  routerParams: any = {};

  constructor(private http: HttpClient, private router: Router) { };



  agInit(params: ICellRendererParams): void {
    this.routerParams = params.data;
    const customer_details_url = `/api/contacts/contact_details.php?uuid=${params.data.customer_contact_uuid}`;
    const sales_details_url = `/api/contacts/contact_details_profiles.php?table=internal_sales&uuid=${params.data.internal_sale_uuid}`;
    const financial_details_url = `/api/quotes/quote_details.php?uuid=${params.data.lading_spot_quote_uuid}`;
    this.http.get<any>(customer_details_url).subscribe(response => {
      if (response) {
        this.customer_details = response;
        if (response['contact_addresses'][0]) {
          this.customer_address_details = response['contact_addresses'][0]
        }
      }
    });

    this.http.get<any>(sales_details_url).subscribe(response => {
      if (response) {
        this.internal_sales_details = response;
      }
    });

    const financialParamsGetRequest = {
      name: 'financial',
    };
    this.http.get<any>(financial_details_url, { params: financialParamsGetRequest }).subscribe(response => {
      if (response[0]) {
        this.financial_details = response[0];
      }
    })
    this.details = params.data;
  }
  refresh(params: ICellRendererParams): boolean {
    throw new Error('Method refresh not implemented.');
  }

  openMap(): void {
    let origin = this.details.origin_locality;
    let destination = this.details.destination_locality;
    window.open('/map/' + origin + '/' + destination, '_blank', 'popup,width=1280px,height=720px');
  }

  printQuote() {
    console.log('quote printed')
  }

  viewQuote() {
    const serializedObject = JSON.stringify(this.routerParams);
    this.router.navigate([`/full-quote-details`], {
      queryParams: {
        data: serializedObject
      }
    });
  }

  createQuote() {
    console.log('quote created')
  }

  deleteQuote() {
    console.log('quote deleted')
  }

}
